import React from 'react';
import PropTypes from 'prop-types';
import styles from '../options.scss';

const OptionButton = ({ clickHandler, id, iconClass, isMainAction, title, noChildren = false }) => {
    let className = styles.optionItem;
    className += isMainAction ? ' main' : '';
    className += noChildren ? '' : ` ${styles.optionButton}`;
    const attrs = {
        onClick: clickHandler,
        className,
    };

    if (id) {
        attrs.id = id;
    }

    return (
        <button {...attrs}>
            <i className={iconClass} aria-hidden="true" />
            <span>{title}</span>
        </button>
    );
};

OptionButton.propTypes = {
    isMainAction: PropTypes.bool,
    clickHandler: PropTypes.func.isRequired,
    id: PropTypes.string,
    iconClass: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    noChildren: PropTypes.bool,
};

export default OptionButton;
